import * as React from 'react';

//import 'rc-CheckBox/assets/index.css';

interface CheckBoxProps {
    label?: string;
    value: boolean;
    labelStyle?: React.CSSProperties;
    labelPosition?: "Left" | "Right";
    disabled?: boolean;
    onChange: (value: boolean) => void;
    style?: any;
    contentStyle?: React.CSSProperties;
}

export default class CheckBox extends React.Component<CheckBoxProps, {}> {
    constructor(props) {
        super(props)
    }

    onClick(e: React.MouseEvent<any>) {
        if (!this.props.disabled)
            this.props.onChange(!this.props.value);

        e.stopPropagation();
    }

    render() {
        return <div className="form-control-static"
            style={{
                display: "-webkit-inline-box",
                flexDirection: "row",
                WebkitBoxAlign: 'center',
                ...this.props.contentStyle
                // marginLeft: "40%"
            } as any}>
            {this.props.label
                && this.props.labelPosition === "Left"
                && <div
                    onClick={(e) => this.onClick(e)}
                    style={{
                        marginRight: 6,
                        cursor: !this.props.disabled ? "pointer" : "not-allowed",
                        ...this.props.labelStyle
                    }}>{this.props.label}</div>}
            <div 
            className="checkbox-dm"
            style={{
                width: 20,
                height: 20,
                marginLeft: 2,
                alignSelf: "center",
                textAlign: "center",
                backgroundColor: "#3B4370",
                border: "3px solid #3B4370",
                borderRadius: 5,
                cursor: !this.props.disabled ? "pointer" : "not-allowed",
                ...this.props.style
            }}
                onClick={(e) => this.onClick(e)}>
                {this.props.value &&
                    <i style= {{ margin: 0, color: "#E5E5E5" }} className="glyphicon glyphicon-ok icon-check-dm"></i>}
            </div>
            {this.props.label
                && this.props.labelPosition !== "Left"
                && <div onClick={(e) => this.onClick(e)}
                    style={{
                        marginLeft: 6,
                        cursor: !this.props.disabled ? "pointer" : "not-allowed",
                        ...this.props.labelStyle
                    }}>{this.props.label}</div>}
        </div>;
    }
}